const env: ImportMetaEnvAugmented = import.meta.env

export const config = {
    apiUrl: env.VITE_API_URL ?? "",
    link440Skjema: env.VITE_OVERSIKT_LINK_440_SKJEMA,
    linkIstPlasseringer: env.VITE_OVERSIKT_LINK_IST_PLASSERINGER,
    linkIstFamilieopplysninger: env.VITE_OVERSIKT_LINK_IST_FAMILIEOPPLYSNINGER,
    linkBarnehageBaseUrl: env.VITE_OVERSIKT_LINK_BARNEHAGE_BASE_URL,
    linkFakturaApp: env.VITE_OVERSIKT_LINK_FAKTURA_APP,
    unleashToken: env.VITE_UNLEASH_TOKEN,
    unleashUrl: env.VITE_UNLEASH_URL,
}
